import { useEffect, useId } from "react";
import { useUser } from "../../context/useInfo";
import amplitude from "../../utils/amplitude";
import ReactGA from "../../utils/googleAnalytics";

const SubscribeSuccess = () => {
  const { userData, updateUserData } = useUser();

  const handleSendQuiz = async (data) => {
    try {
      const res = await fetch(
        "https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/receiveWebQuizData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa("quiz_admin:s*Q&FLx^9BUQ"),
          },
          body: JSON.stringify(data),
        }
      );
      if(process.env.NODE_ENV === "production"){
        ReactGA.event({
          category: "Payment",
          action: "success",
        });
        const price = localStorage.getItem('price');
        fbq('track', 'Subscribe Success', {value: price, currency: 'USD', predicted_ltv: '0.00'});
        amplitude.track("Payment Success", {value: price, currency: 'USD'});
      }

      if (res.ok) {
        console.log("Ответы успешно отправлены");
        return res;
      } else {
        if(process.env.NODE_ENV === "production"){
          amplitude.track("Purchase Failed", {
            error_message: res.error.message || "Unknown error",
          });
        }
        console.log("Ошибка отправки");
      }
    } catch (err) {
      console.log("Ошибка при соединении с сервером");
    }
  };
  
  useEffect(() => {

    const res = localStorage.getItem("userData");
    const data = JSON.parse(res);
    

    if (!data) return;

    const sendData = async () => {
      const questionsAndAnswers = Object.entries(data).map(
        ([question, value]) => ({
          question,
          answer: Array.isArray(value)
            ? value.join(", ")
            : typeof value === "object" && value !== null
            ? value.label || value.title || JSON.stringify(value)
            : value,
        })
      );

      await handleSendQuiz(questionsAndAnswers);

    };

    sendData();
  }, [userData]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      {/* Иконка галочки */}
      <img
        src="/done.svg" // замените на путь к вашей галочке
        alt="Done"
        className="w-40 h-40 mb-6"
      />

      {/* Текст "Done!" */}
      <h1 className="text-3xl font-bold text-pink-500 mb-2">Done!</h1>

      {/* Текст "Payment success" */}
      <p className="text-lg font-medium text-gray-800 mb-4">Payment success</p>

      {/* Подтекст */}
      <p className="text-center text-gray-500 mb-3">
        To proceed, please download <br/> Solvi App and log in using the same email as<br/> you provided here.<br />
        To manage your subscription, use the <a target="blank" className="text-pink-600 underline mb-5" href="https://billing.stripe.com/p/login/dRmbJ2aUX8gb6rfftCcMM00">
          Customer Portal
          </a><br/> or contact our support team
      </p>
      <a className="text-pink-600 underline mb-5" href="mailto:support@solvi.club">
        support@solvi.club
      </a>

      {/* Кнопка App Store */}
      <a
        href="https://apps.apple.com/app/id6503243188"
        className="inline-flex gap-1 items-center justify-center bg-black text-white px-4 py-1 rounded-lg shadow hover:bg-gray-900 transition"
      >
        <svg
          fill="#ffffff"
          width="40px"
          height="40px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"></path>{" "}
          </g>
        </svg>
        <div className="flex flex-col">
          <p className="text-sm tracking-wide">Download on the</p>
          <span className="w-full text-left text-2xl tracking-wide">
            App Store
          </span>
        </div>
      </a>
    </div>
  );
};

export default SubscribeSuccess;
